import React, { useState } from "react";

const TONI = {
  red: { box: "border-2 border-red-300", head: "text-red-800", badge: "bg-red-600" },
  emerald: { box: "border border-slate-200", head: "text-emerald-800", badge: "bg-emerald-600" },
  amber: { box: "border-2 border-amber-300", head: "text-amber-800", badge: "bg-amber-500" },
  violet: { box: "border-2 border-violet-300", head: "text-violet-800", badge: "bg-violet-600" },
  sky: { box: "border border-slate-200", head: "text-sky-800", badge: "bg-sky-600" },
  teal: { box: "border border-slate-200", head: "text-teal-800", badge: "bg-teal-600" },
};

export function RiepBox({ icon: Icon, titolo, count, tono = "teal", testid, children }) {
  const t = TONI[tono] || TONI.teal;
  return (
    <div className={`rounded-2xl bg-white p-3 shadow-sm ${t.box}`} data-testid={testid}>
      <div className={`flex items-center gap-2 mb-2 font-head font-bold text-sm ${t.head}`}>
        {Icon && <Icon size={16} />} {titolo}
        <span className={`ml-auto text-white text-xs font-bold rounded-full px-2 py-0.5 tabnum ${t.badge}`} data-testid={`${testid}-count`}>{count}</span>
      </div>
      {children}
    </div>
  );
}

export const RiepSotto = ({ children }) => <div className="text-[11px] font-bold uppercase tracking-wide text-slate-500 mt-1">{children}</div>;
export const RiepVuoto = ({ children }) => <div className="text-xs text-muted-foreground py-1">{children}</div>;

export function RiepLista({ items, max = 5, render, testid, vuoto }) {
  const [tutti, setTutti] = useState(false);
  if (!items.length) return <RiepVuoto>{vuoto}</RiepVuoto>;
  return (
    <>
      <div className={tutti ? "max-h-72 overflow-y-auto pr-1" : ""}>{(tutti ? items : items.slice(0, max)).map(render)}</div>
      {items.length > max && <button type="button" onClick={() => setTutti(!tutti)} className="text-[11px] font-semibold text-emerald-700 py-1" data-testid={`${testid}-tutti`}>{tutti ? "Mostra meno" : `+ altre ${items.length - max}…`}</button>}
    </>
  );
}

export const rigaCls = "w-full flex items-center gap-2 py-1.5 border-b last:border-0 text-[13px] text-left";
export const fmtGiornoLungo = (s) => (s ? new Date(String(s).slice(0, 10) + "T12:00:00").toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" }) : "");
export const oggiRm = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });

export const TagRicetta = ({ evento, ambito }) => (evento
  ? <span className="shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-red-100 text-red-700">evento sanitario</span>
  : ambito === "bisogno" ? <span className="shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800">terapia al bisogno</span>
  : <span className="shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-violet-100 text-violet-700">terapia ordinaria</span>);

export const ScadenzaRicetta = ({ scadenza }) => {
  const scaduta = scadenza && scadenza < oggiRm();
  return <span className={`ml-auto shrink-0 text-[11px] font-semibold ${scaduta ? "text-red-600" : "text-amber-700"}`}>{scaduta ? "scaduta" : "entro"} {fmtGiornoLungo(scadenza)}</span>;
};
